import { Koi } from '@ksyos/koi';

export function getTodayOrBeforeDateSchema() {
    return Koi.koi().todayOrBefore().concat(Koi.koi().date());
}
